import { Component, OnInit } from '@angular/core';
import { DownloadNotificationService } from '../../root-services/download-notification.service';

import { DownloadsNotificationState } from './../../models/global/downloads-notification';
import { DownloadState } from './../../models/global/download-state';

// RxJS Interfaces
import { Subject } from 'rxjs/Subject';

@Component({
  selector: 'app-download-notification',
  templateUrl: './download-notification.component.html',
  styleUrls: ['./download-notification.component.less']
})
export class DownloadNotificationComponent implements OnInit {

    public existingDNState: DownloadsNotificationState;
    public completeAndUnclickedArray: DownloadState[] = [];
    public incompleteArray: DownloadState[] = [];
    public popupOpen = false;

    constructor(private downloadNotificationService: DownloadNotificationService) {}

    ngOnInit() {
        this.downloadNotificationService.downloadsNotificationStateBroadcast
          .subscribe((newDNState: DownloadsNotificationState) => {
            let newCompleteAndUnclickedArray = newDNState.downloads
            .filter(newD => newD.state === 'complete')
            .filter(completedNewD => this.existingDNState.downloads.find(existingD => completedNewD.token === existingD.token))
            .filter(completedMatchingNewD => {
                let token = completedMatchingNewD.token;
                return this.existingDNState.downloads
                    .find(existingD => completedMatchingNewD.token === existingD.token).state !== 'complete';
            })
            let incompleteArray = newDNState.downloads
            .filter(newD => newD.state !== 'complete')

            if (newCompleteAndUnclickedArray && newCompleteAndUnclickedArray.length > 0) this.popupOpen = true;
            this.completeAndUnclickedArray = newCompleteAndUnclickedArray.concat(this.completeAndUnclickedArray);
            this.incompleteArray = incompleteArray;

            this.existingDNState = newDNState;
          });
    }

    public download(download: DownloadState) {
        let download_url = download.download_url;
        this.clearPopup(download.token);
        window.open(download_url);
    }

    public clearPopup(token) {
        this.completeAndUnclickedArray = this.completeAndUnclickedArray.filter(popup => popup.token !== token);
        if (this.completeAndUnclickedArray.length === 0) this.popupOpen = false;
    }
}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/shared/download-notification/download-notification.component.ts